// pages/ForgotPassword/ForgotPassword.tsx
import React from 'react';

import { useForgotPassword } from '@/hooks/auth/useForgotPassword';
import ForgotPasswordForm from '@/components/organism/ForgotPassword/ForgotPasswordForm';

export default function ForgotPassword() {
  const { state, handlers } = useForgotPassword();

  return (
    <>
      <div className="text-center mb-6">
        <h1 className="text-3xl font-bold text-foreground mb-2">Reset your password</h1>
        <p className="text-muted-foreground text-lg">
          Enter the email address associated with your account
        </p>
      </div>
      <ForgotPasswordForm
        onSubmit={handlers.submit}
        isLoading={state.isLoading}
        error={state.error}
      />
    </>
  );
}
